import { AppRoutes } from "./routes";

export const App = () => {
  return <AppRoutes />;
};
